import type { CSSObject } from '@emotion/react'
import { Color, Size, Spacing } from '@opallabs/gem'

const card: CSSObject = {
  inlineSize: Spacing.XL * 7.5,
  background: 'transparent',
  borderRadius: Size.Rounding * 2,
}

const cardBody = (stickyNote: boolean): CSSObject => ({
  background: stickyNote ? '#fff8e3' : Color.light.Surface.N000,
  blockSize: stickyNote ? Spacing.M * 7.8125 : undefined,
  flexDirection: 'column',
  alignItems: 'start',
  padding: 0,
})

const image: CSSObject = {
  inlineSize: '100%',
}

const storyRow: CSSObject = {
  color: Color.light.Text.Gray,
  display: 'flex',
  alignItems: 'center',
  marginBlockStart: Spacing.M,
  marginInline: Spacing.M,
  fontSize: '14px',
}

const storyIcon = (storyColor?: string): CSSObject => ({
  color: storyColor || Color.light.Text.Gray,
  marginInlineEnd: Spacing.XS,
  paddingBlockEnd: Spacing.XS / 4,
})

const title: CSSObject = {
  fontSize: 20,
  margin: Spacing.M,
  marginBlockEnd: Spacing.S,
  inlineSize: `calc(100% - ${Spacing.M * 2}px)`,
}

const dateRange: CSSObject = {
  color: Color.light.Text.Gray,
  marginInline: Spacing.M,
  marginBlockEnd: Spacing.L,
  fontSize: 14,
}

const divider: CSSObject = {
  backgroundColor: Color.light.Surface.N300,
}

const footer: CSSObject = {
  backgroundColor: '#f7f8fa',
  paddingBlock: Spacing.S,
  paddingInline: Spacing.M,
}

const channelIcons: CSSObject = {
  border: `1px solid ${Color.light.Surface.N300}`,
  backgroundColor: Color.light.Surface.N000,
  blockSize: Spacing.M * 2,
  inlineSize: Spacing.M * 2,
  borderRadius: Size.Rounding * 1.5,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginInlineEnd: Spacing.S,
}

export const styles = {
  card,
  cardBody,
  image,
  channelIcons,
  dateRange,
  storyRow,
  storyIcon,
  footer,
  title,
  divider,
}
